import { findActiveTriggerRange, gatherFilteredCommands, getAutocompleteSpan, keepIndexBetweenArrayBounds, AUTOCOMPLETE_MODES, removeSpanAndResetState, getTextForRangeWithoutTrigger
// @ts-expect-error not typed yet
} from './utils';
import { updateAutocompleteQuickInsertIsActiveAtom, updateFilteredAutocompleteCommands, autocompleteQuickInsertIsActiveAtom, updateActiveAutocompleteCommand, activeAutocompleteCommandAtom, updateAutocompleteEscaped, autocompleteEscapedAtom, updateAutocompleteActiveRange, updateActiveAutocompleteTrigger
// @ts-expect-error not typed yet
} from '../data/autocompleteAtoms';
import { resetCommandSelectedOnEnter } from './navigationHandler';
import { getAtomValue } from '../data/atomUtils';
export default async function handleAutocompleteQuickInsertChange(editor) {
  const triggerMap = editor.autocompleteQuickInsertOptions;
  if (!triggerMap) {
    return;
  }
  const autocompleteQuickInsertIsActive = getAtomValue(autocompleteQuickInsertIsActiveAtom);
  const autocompleteEscaped = getAtomValue(autocompleteEscapedAtom);
  const {
    activeTrigger,
    activeAutocompleteRange
  } = findActiveTriggerRange(editor, Object.keys(triggerMap), AUTOCOMPLETE_MODES.QUICK_INSERT);
  if (!activeTrigger) {
    if (autocompleteQuickInsertIsActive) {
      removeSpanAndResetState(editor);
    }
    if (autocompleteEscaped) {
      // Moved out of autocomplete range, so reset the "escaped" state
      updateAutocompleteEscaped(false);
    }
    return;
  }
  if (autocompleteEscaped) {
    // Bail early if current autocomplete range is "escaped" so that we don't
    // reopen the menu
    return;
  }
  if (autocompleteQuickInsertIsActive) {
    // If it's not active right now, we'll update the range later when we activate the menu
    updateAutocompleteActiveRange(activeAutocompleteRange);
  }
  const filtersForActiveTrigger = triggerMap[activeTrigger];
  const rangeText = getTextForRangeWithoutTrigger(activeAutocompleteRange, false);
  const filteredCommands = await gatherFilteredCommands(filtersForActiveTrigger, rangeText);
  const currentActiveAutocompleteCommandIndex = getAtomValue(activeAutocompleteCommandAtom);
  const activeCommandIndexBoundToUpdatedCommands = keepIndexBetweenArrayBounds(currentActiveAutocompleteCommandIndex, filteredCommands.length);
  updateActiveAutocompleteTrigger(activeTrigger);
  updateActiveAutocompleteCommand(activeCommandIndexBoundToUpdatedCommands);
  updateFilteredAutocompleteCommands(filteredCommands);
  // Careful, the order that these are fired matters because react may update in between
  if (!autocompleteQuickInsertIsActive) {
    resetCommandSelectedOnEnter();
    activeAutocompleteRange.insertNode(getAutocompleteSpan());
    // Recompute the active range since our range has now changed after inserting the span
    // This makes sure that our onNodeChange handler below doesn't close the menu when typing the trigger
    const {
      activeAutocompleteRange: recomputedActiveRange
    } = findActiveTriggerRange(editor, [], AUTOCOMPLETE_MODES.QUICK_INSERT);
    updateAutocompleteActiveRange(recomputedActiveRange);
    updateAutocompleteQuickInsertIsActiveAtom(true);
    updateActiveAutocompleteCommand(0);
  }
}